export const pluralize = (
  count: number,
  noun: string,
  suffix = 's',
  hideCount = false
) => `${hideCount ? '' : count} ${noun}${count !== 1 ? suffix : ''}`;
